import { Bar } from './StickyActionBar.styles';
import type { StickyActionBarProps } from './StickyActionBar.types';

export const StickyActionBar = ({ children, ...props }: StickyActionBarProps) => (
  <Bar {...props}>{children}</Bar>
);
